import SpecialBogo from 'src/dispensary/specials/offer';
import { CoreMenuLayout } from 'components/layouts/core-menu-layout';
import { getDispensaryServerSideProps } from 'src/utils/ssr/get-dispensary-server-side-props';

export const getServerSideProps = getDispensaryServerSideProps;

SpecialBogo.layout = CoreMenuLayout;
export default SpecialBogo;
